import * as amplitude from "@amplitude/analytics-browser";

import { AmplitudeEvent } from "@/shared/config";

export const initAmplitude = () => {
  amplitude.init(import.meta.env.VITE_AMPLITUDE_API_KEY as string, {
    autocapture: false,
  });
};

export const trackAmplitudeEvent = (
  event: AmplitudeEvent,
  properties?: Record<string, string>
) => {
  amplitude.track(event, properties);
};
